/** Dark-colored wordmark for light backgrounds (tabs, Turnkey light UI, QR on white). */
export const LOGO_SRC_LIGHT_BACKGROUND = '/assets/logo-dark.svg';

/** White wordmark for dark backgrounds. */
export const LOGO_SRC_DARK_BACKGROUND = '/assets/logo-white.svg';

/** Dark-colored beta lockup for light backgrounds. */
export const LOGO_BETA_SRC_LIGHT_BACKGROUND = '/assets/logo-beta-dark.svg';

/** White beta lockup for dark backgrounds. */
export const LOGO_BETA_SRC_DARK_BACKGROUND = '/assets/logo-beta-white.svg';

/** Dark O mark for light backgrounds. */
export const O_MARK_SRC_LIGHT_BACKGROUND = '/assets/o-mark-dark.svg';

/** White O mark for dark backgrounds. */
export const O_MARK_SRC_DARK_BACKGROUND = '/assets/o-mark-white.svg';

/** Wordmark viewBox width / height from source SVG (`0 0 60 26`). */
export const LOGO_WORDMARK_ASPECT_RATIO: number = 60 / 26;

/** Beta lockup viewBox width / height from source SVG (`0 0 90 21`). */
export const LOGO_BETA_ASPECT_RATIO: number = 90 / 21;

/** Default export for static contexts that assume a light UI surface. */
export const LOGO_SRC: string = LOGO_SRC_LIGHT_BACKGROUND;

export function logoWordmarkWidthForHeight(heightPx: number): number {
  return Math.round(heightPx * LOGO_WORDMARK_ASPECT_RATIO);
}

export function logoBetaWidthForHeight(heightPx: number): number {
  return Math.round(heightPx * LOGO_BETA_ASPECT_RATIO);
}
